var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 54,
    viewBox: "0 0 7 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 862"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3179",
    x: 2,
    width: 3,
    height: 36,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 153",
    d: "M4 5L6.38675 8.68157e-08L0.613248 -8.68157e-08L3 5L4 5ZM3 49L0.613246 54L6.38675 54L4 49L3 49ZM3 2L3 4L4 4L4 2L3 2ZM3 5L3 7L4 7L4 5L3 5ZM3 8L3 10L4 10L4 8L3 8ZM3 11L3 13L4 13L4 11L3 11ZM3 14L3 16L4 16L4 14L3 14ZM3 17L3 19L4 19L4 17L3 17ZM3 20L3 22L4 22L4 20L3 20ZM3 23L3 25L4 25L4 23L3 23ZM3 26L3 28L4 28L4 26L3 26ZM3 29L3 31L4 31L4 29L3 29ZM3 32L3 34L4 34L4 32L3 32ZM3 35L3 37L4 37L4 35L3 35ZM3 38L3 40L4 40L4 38L3 38ZM3 41L3 43L4 43L4 41L3 41ZM3 44L3 46L4 46L4 44L3 44ZM3 47L3 49L4 49L4 47L3 47ZM3 50L3 52L4 52L4 50L3 50Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderDivider);
export default __webpack_public_path__ + "static/media/slider_divider.519f642e80eb21aeb73e79ed0d1d94c3.svg";
export { ForwardRef as ReactComponent };